import { Component } from 'react';

class Menu extends Component {
  render() {
    return (
        
            <header>
                <nav className="navbar navbar-expand-lg navbar-light top-navbar navbar-custom" data-toggle="sticky-onscroll">
                    <div className="container">
                        <a className="navbar-brand" href={this.props.language}><img src="/static/images/logo-coeladvocaten.png" width="215px" alt="CoelAdvocaten Securing what matters" /></a>
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
            
                        <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
                            <ul className="navbar-nav pull-right">

                            {
                                this.props.menus.map(menu =>
                                    
                                    menu.children == undefined ? 
                                        (
                                        <li key={menu.url} className={"nav-item" + (this.props.selection == menu.name ? 'active' : '')}>
                                            <a className="nav-link" href={menu.url}>{menu.name}</a>
                                        </li>
                                        ) 
                                        : 
                                        (
                                        <li key={(menu.url != undefined ? menu.url : menu.name)} className={"nav-item dropdown" + (this.props.selection == menu.name ? 'active' : '')}>
                                            <a className="nav-link dropdown-toggle" href={menu.url} id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{menu.name}</a>
                                            <div id={(menu.url != undefined ? menu.url : menu.name)} className="dropdown-menu" aria-labelledby="navbarDropdown">
                                                { menu.children.map(child => 
                                                    <a key={child.url} className="dropdown-item" href={child.url}>{child.name}</a>
                                                    )
                                                }
                                            </div>
                                        </li>
                                        )
                                )
                            }

                            {
                                this.props.switches != undefined ?
                                    this.props.switches.map(sw =>
                                        (sw.url != undefined && sw.url != '' ? 
                                            (<li key={sw.url} className={"nav-item "}>
                                                <a className="nav-link" href={sw.url}>{sw.name}</a>
                                            </li>)
                                            : null
                                        )
                                    )
                                :
                                    (this.props.switchUrl != undefined && this.props.switchUrl != '' ? 
                                        (<li key={this.props.switchUrl} className={"nav-item "}>
                                            <a className="nav-link" href={this.props.switchUrl}>{this.props.switchLanguage}</a>
                                        </li>)
                                        : null
                                    )
                            }
                            </ul>
                        </div>
                    </div>
                </nav>
            </header>
            
    );
  }
}

export default Menu
